import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { take } from 'rxjs/operators';

import { FuseSidebarService } from '../../../@fuse/components/sidebar/sidebar.service';
import { SubmissionModel } from '../api/models/SubmissionModel';

export const CONVERT_SUBMISSION_PANEL_NAME = 'convertSubmissionPanel';

export interface ConvertSubmissionPanelData {
  submission: SubmissionModel;
}

/** Right panel « Convertir la soumission » — resolves with the created Event (or false). */
@Injectable({ providedIn: 'root' })
export class ConvertSubmissionPanelService {
  private _result$: Subject<any | false> | null = null;
  private readonly _isOpen$ = new BehaviorSubject<boolean>(false);
  private _data: ConvertSubmissionPanelData | null = null;

  readonly isOpen$ = this._isOpen$.asObservable();

  constructor(private _fuseSidebarService: FuseSidebarService) {}

  open(data: ConvertSubmissionPanelData): Observable<any | false> {
    if (this._result$) {
      this._result$.complete();
    }
    this._result$ = new Subject<any | false>();
    this._data = data;

    this._isOpen$.next(true);
    setTimeout(() => {
      const sidebar = this._fuseSidebarService.getSidebar(
        CONVERT_SUBMISSION_PANEL_NAME,
      );
      sidebar?.open();
    });

    return this._result$.asObservable().pipe(take(1));
  }

  getData(): ConvertSubmissionPanelData | null {
    return this._data;
  }

  emitResult(result: any | false): void {
    const sidebar = this._fuseSidebarService.getSidebar(
      CONVERT_SUBMISSION_PANEL_NAME,
    );
    sidebar?.close();

    this._result$?.next(result);
    this._result$?.complete();
    this._result$ = null;
    this._data = null;
    this._isOpen$.next(false);
  }
}
